export default "__VITE_ASSET__BFpmAwlb__"